<template>
  <div class="flex flex-col gap-[8px] w-full">
    <div class="flex flex-row flex-wrap gap-x-[16px] gap-y-[4px]">
      <div
        v-for="rule in rules"
        :key="rule.key"
        :class="[
          error ? 'text-error' : '',
          result.checks[rule.key]
            ? 'text-success'
            : shouldShowError
            ? 'text-error'
            : 'text-grays-700',
          !shouldShowError ? 'text-grays-700' : '',
        ]"
        class="flex flex-row items-center gap-[4px] text-grays-700"
      >
        <span class="material-symbols-rounded text-base">
          {{
            !shouldShowError
              ? "check_circle"
              : result.checks[rule.key]
              ? "check_circle"
              : "cancel"
          }}
        </span>
        <p class="text-xs font-medium">{{ rule.label }}</p>
      </div>
    </div>

    <div v-if="password" class="flex flex-col gap-[4px]" aria-live="polite">
      <div class="flex flex-row gap-[4px]" aria-hidden="true">
        <div
          v-for="n in 4"
          :key="n"
          class="h-[4px] flex-1 rounded-full"
          :class="n <= level.bars ? level.color : 'bg-grays-200'"
        ></div>
      </div>
      <p class="text-xs font-medium" :class="level.text">
        חוזק הסיסמה: {{ level.label }}
      </p>
    </div>
  </div>
</template>

<script>
import { evaluatePassword, loadZxcvbn } from "@/utils/passwordRules";

const RULES = [
  { key: "length", label: "10 תווים" },
  { key: "upper", label: "אות גדולה" },
  { key: "lower", label: "אות קטנה" },
  { key: "digit", label: "ספרה" },
  { key: "noSpaces", label: "בלי רווחים" },
  { key: "strong", label: "לא קלה לניחוש" },
];

// Four levels, zxcvbn score 0-1 → 1 bar, 2 → 2, 3 → 3, 4 → 4.
const LEVELS = [
  { bars: 1, label: "חלשה", color: "bg-error", text: "text-error" },
  { bars: 2, label: "בינונית", color: "bg-[#F59E0B]", text: "text-[#B45309]" },
  { bars: 3, label: "טובה", color: "bg-[#84CC16]", text: "text-[#4D7C0F]" },
  { bars: 4, label: "חזקה", color: "bg-success", text: "text-success" },
];

export default {
  name: "password-checks",
  props: {
    password: {
      type: String,
      default: "",
    },
    // What the password must not equal: { phones, username, tzl, tzw, email }
    context: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Boolean,
      default: false,
    },
    shouldShowError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:valid"],
  data() {
    return { zxcvbn: null, rules: RULES };
  },
  computed: {
    result() {
      return evaluatePassword(this.password, this.context, this.zxcvbn);
    },
    level() {
      return LEVELS[Math.max(0, this.result.score - 1)];
    },
  },
  watch: {
    "result.valid": {
      immediate: true,
      handler(valid) {
        this.$emit("update:valid", valid);
      },
    },
  },
  mounted() {
    loadZxcvbn().then((fn) => {
      this.zxcvbn = fn;
    });
  },
};
</script>
